import { useEffect } from 'react'

import { useDisplayManager } from 'components/DisplayManager'

import useSaveConsent from 'hooks/useSaveConsent'

import isScrolledToAccept from './lib/isScrolledToAccept'


export default function useScrollToAccept({ isEnabled }) {
  const { acceptAll } = useSaveConsent()
  const { closeAllUI } = useDisplayManager()

  useEffect(() => {
    if ( !isEnabled ) {
      return
    }

    const onScroll = (e) => {
      if ( !isScrolledToAccept() ) {
        return
      }

      closeAllUI()
      acceptAll()
    }

    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [acceptAll, closeAllUI, isEnabled])
}
